<template>
  <AccountModal
    v-if="showAccountModal"
    @closeModal="showAccountModal = !showAccountModal"
  />
  <div
    class="navbar navbar-dark navbar-expand-lg navbar-static border-bottom border-bottom-white border-opacity-10"
  >
    <div class="container-fluid ps-1">
      <div class="navbar-brand">
        <router-link
          to="/home"
          class="d-inline-flex align-items-center"
          title="Home"
        >
          <img
            src="@/assets/img/senar.png"
            class="h-32px"
            alt="Logo do Senar"
          />
        </router-link>
      </div>
      <div class="d-xl-none">
        <button
          type="button"
          class="navbar-toggler"
          data-bs-toggle="collapse"
          data-bs-target="#navbar-navigation"
          aria-expanded="true"
          title="Expandir/Recolher"
        >
          <i class="ph-list" />
        </button>
      </div>
      <div class="navbar-collapse collapse" id="navbar-navigation">
        <ul class="navbar-nav ms-auto">
          <li class="nav-item">
            <router-link
              to="/projects"
              class="navbar-nav-link rounded"
              title="Sumários Executivos"
            >
              Sumários Executivos
            </router-link>
          </li>
          <li class="nav-item dropdown ms-xl-1" title="Registros">
            <a
              href="#"
              class="navbar-nav-link rounded dropdown-toggle"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              Cadastros
            </a>
            <div class="dropdown-menu dropdown-menu-end">
              <router-link
                to="/registries/bidders"
                class="dropdown-item"
                title="Gestão de Proponentes"
              >
                <i class="ph-identification-card me-2" />Proponentes
              </router-link>
              <router-link
                to="/registries/partners"
                class="dropdown-item"
                title="Gestão de Parceiros"
              >
                <i class="ph-handshake me-2" />Parceiros
              </router-link>
            </div>
          </li>
          <li
            v-if="getProfileById(profileAdmin)"
            class="nav-item dropdown ms-xl-1"
            title="Área Administrativa"
          >
            <a
              href="#"
              class="navbar-nav-link rounded dropdown-toggle"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              Administração
            </a>
            <div class="dropdown-menu dropdown-menu-end">
              <router-link
                to="/admin/users"
                class="dropdown-item"
                title="Gestão de Usuários"
              >
                <i class="ph-users me-2" />Usuários
              </router-link>
            </div>
          </li>
          <li class="nav-item dropdown ms-xl-1">
            <a
              href="#"
              class="navbar-nav-link rounded dropdown-toggle"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              {{ user.name }}
            </a>
            <div class="dropdown-menu dropdown-menu-end">
              <button
                class="dropdown-item"
                @click="showAccountModal = true"
                title="Meu Perfil"
              >
                <i class="ph-user-circle me-2" />Meu Perfil
              </button>
              <div class="dropdown-divider"></div>
              <button class="dropdown-item" @click="logout" title="Sair">
                <i class="ph-sign-out me-2" />Sair
              </button>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import AccountModal from '@/components/account/AccountModal.vue'
import PATHS from '@/router/routesMap'
import ProfileEnum from '@/enum/profileEnum'

export default {
  name: 'Navbar',

  components: {
    AccountModal,
  },

  data() {
    return {
      showAccountModal: false,
    }
  },

  computed: {
    ...mapGetters(['user', 'getProfileById']),

    currentRouteName() {
      return this.$route.name
    },

    profileAdmin() {
      return ProfileEnum.ADMINISTRADOR
    },
  },

  methods: {
    logout() {
      this.$store.dispatch('logout').then(() => {
        localStorage.clear()
        this.$router.push(PATHS.BASE_URL)
      })
    },
  },
}
</script>
